import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=e988da3e&scoped=true"
import script from "./ProcessList.vue?vue&type=script&lang=js"
export * from "./ProcessList.vue?vue&type=script&lang=js"
import style0 from "./ProcessList.vue?vue&type=style&index=0&id=e988da3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e988da3e",
  null
  
)

export default component.exports